import React from 'react';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { ComparisonTable } from './components/ComparisonTable';
import { ProblemSection } from './components/ProblemSection';
import { EmailSocialProof } from './components/EmailSocialProof';
import { ProjectCarousel } from './components/ProjectCarousel';
import { ProductPresentation } from './components/ProductPresentation';
import { BonusGrid } from './components/BonusGrid';
import { ImpactShowcase } from './components/ImpactShowcase';
import { TrustSection } from './components/TrustSection';
import { PriceBox } from './components/PriceBox';
import { VideoMockupSection } from './components/VideoMockupSection';
import { FAQSection } from './components/FAQSection';
import { CommentsSection } from './components/CommentsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-[#fdf8f3] font-sans selection:bg-[#d97706]/30 selection:text-gray-900 text-gray-800" data-id="element-0" data-mp="3ii4ro0w5cqo1">
      <MetaPixel data-id="element-1" data-mp="3rcj31sdk3h1v" />
      <TopBanner data-id="element-2" data-mp="3rbzq6q2rjiup" />

      <main className="flex flex-col" data-id="element-3" data-mp="3rdkkqfp2v1sk">
        <HeroSection data-id="element-4" data-mp="5yk6vxnnffx" />
        <ComparisonTable data-id="element-5" data-mp="6hp9c27i9cj" />
        <ProblemSection data-id="element-6" data-mp="4n53zyrel9i" />
        <EmailSocialProof data-id="element-7" data-mp="56qxrrj5tst" />
        <ProjectCarousel data-id="element-8" data-mp="2zl3cxocsjc6w" />
        <ProductPresentation data-id="element-9" data-mp="2zlv8x0aavbxp" />
        <BonusGrid data-id="element-10" data-mp="2zmo7vf30ox5a" />
        <ImpactShowcase data-id="element-11" data-mp="2zng1ikd20ksx" />
        <TrustSection data-id="element-12" data-mp="33mf0zpg0npcz" />
        <PriceBox data-id="element-13" data-mp="33nq73vwxp979" />
        <VideoMockupSection data-id="element-14" data-mp="33n6yj5t6bx5w" />
        <CommentsSection data-id="element-15" data-mp="33oi1j3esp0vy" />
        <TestimonialsSection data-id="element-16" data-mp="38l8iru2c62iy" />
        <FAQSection data-id="element-17" data-mp="38l05w267qx7r" />
      </main>

      <footer className="bg-[#fdf8f3] py-12 border-t border-gray-200 text-center" role="contentinfo" data-id="element-18" data-mp="38o4gbha9up6v">
        <div className="max-w-7xl mx-auto px-4" data-id="element-19" data-mp="nvst52eusjuw">
          <p className="text-gray-600 text-sm mb-2" data-id="element-20" data-mp="nv1284w7baay">
            © 2026 Digital Factory. Todos los derechos reservados.
          </p>
          <p className="text-gray-400 text-sm mb-4" data-id="element-21" data-mp="36hx792iaw2a">
            Soporte:{' '}
            <a href="mailto:soportesinfinstudio@gmail.com" className="hover:text-white transition-colors" data-id="element-22" data-mp="38kvegdtbvi3">
              soportedigitalfactory@gmail.com
            </a>
          </p>
          <p className="text-gray-400 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-23" data-mp="85l0anyxes7m">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <PurchaseNotifications data-id="element-24" data-mp="3qbzemo13x46j" />
    </div>;
}